{
  "name": "oral-b-fr-es-store",
  "customRoutes": {},
  "hasNewsletter": true,
  "hasPromotions": true,
  "maxItemQuantity": 5,
  "maxOrderQuantity": 10,
  "homeModuleCarousel": {
    "useFeedId": true,
    "feedId": 71622,
    "carouselLimit": 12,
    "title": "Featured Products"
  },
  "currency": "EUR",
  "browserLogLevel": "error"
}